function getTitle (vm) {
  const title = vm.$route?.meta?.title
  if (title) return title + ' - Hauseful'
}

export default {
  created () {
    const title = getTitle(this)
    if (title) {
      document.title = title
    }
  }
}
